import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextFieldWithValidation } from '../../material-ui-wrappers/with-validations';
import { passwordsMatch } from '../../util/validations';

const PasswordChangeInputsComponent = ({
  classes,
  model,
  handleChange,
  hasSubmitted,
  validations
}) => (
  <Fragment>
    <TextFieldWithValidation
      id='password'
      type='password'
      label='Password'
      name='password'
      value={model.password}
      onChange={handleChange}
      className={`${classes.textField}`}
      InputProps={{
        className: classes.input
      }}
      InputLabelProps={{
        className: classes.textField
      }}
      margin='normal'
      rules={validations['password']}
      formSubmitted={hasSubmitted}
    />

    <TextFieldWithValidation
      id='passwordCheck'
      type='password'
      label='Verify Password'
      name='checkPassword'
      value={model.checkPassword}
      onChange={handleChange}
      className={`${classes.textField}`}
      InputProps={{
        className: classes.input
      }}
      InputLabelProps={{
        className: classes.textField
      }}
      margin='normal'
      rules={[passwordsMatch(model.password)]}
      formSubmitted={hasSubmitted}
    />
  </Fragment>
);

const styles = theme => ({
  textField: {
    margin: theme.spacing.unit,
    display: 'flex'
  }
});

export const PasswordChangeInputs = withStyles(styles)(
  PasswordChangeInputsComponent
);
